import eventListeners from './event-listeners';
import documentPasteHandler from '../handlers/document-paste-handler';

const pasteListener = (element) => {
  eventListeners.add(element, 'paste', documentPasteHandler, true);
};

export default pasteListener;
